import React, { Component } from 'react';
import { PrimaryButton } from '../../components/BasicForm/PrimaryButton';
class Landing extends Component {
  state = {
		heading: 'Applying for Visitation',
		showProgressBar: false,
		pageId: 'visitation-intro',
	}
	componentWillMount() {
    const stepData = this.props.stepData;
		this.props.setHeaderDisplay(
			this.state.heading,
      stepData.displayStep,
      this.state.showProgressBar,
      this.state.pageId,
      stepData.step,
		);
	}
  handlePrimaryClick = () => {
    const stepData = this.props.stepData;
    this.props.nextStep(stepData);
  }
  render() {
    return(
      <div className="col-19">
        <ul className="icon-list">
          <li>
            <img 
              className="li-icon" 
              src="/images/icons/who-you-can-visit.svg" 
              aria-hidden="true" 
              alt="" />
            <div className="li-info">
              <h3 className="multiline-heading">Who you can visit</h3>
              <p>Only applications to visit inmates housed in a Virginia Department of Corrections (VADOC) facility will be accepted. If you would like to visit an inmate in a local or regional jail, or a Detention and Diversion Center, please contact that jail about their application process.</p>
            </div>
          </li>
          <li>
            <img 
              className="li-icon" 
              src="/images/icons/how-it-works.svg" 
              aria-hidden="true" 
              alt="" />
            <div className="li-info">
              <h3 className="multiline-heading">How it works</h3>
              <p>If you would like to visit an inmate in a VADOC facility, you must complete a visitation application. Once submitted, we will email you to confirm receipt of your application. All applications for minors must be attached to an adult application.</p>
            </div>
          </li>
          <li>
            <img 
              className="li-icon" 
              src="/images/icons/how-long-to-apply.svg" 
              aria-hidden="true" 
              alt="" />
            <div className="li-info">
              <h3 className="multiline-heading">How long it takes to apply</h3>
              <p>The online application process will take about 20-30 minutes. You cannot save your answers as a draft, so you will need to complete the form and submit in one sitting.</p>
            </div>
          </li>
          <li>
            <img 
              className="li-icon" 
              src="/images/icons/items-needed.svg" 
              aria-hidden="true" 
              alt="" />
            <div className="li-info">
              <h3 className="multiline-heading">Items you need to complete application</h3>
              <p>Before you begin, make sure you've collected the following:</p>
              <ol>
                <li>The inmate's first and/or last name OR inmate ID number</li>
                <li>A form of picture ID (your driver's license, passport, etc.)</li>
                <li>Your Social Security Number</li>
              </ol>
            </div>
          </li>
          <li>
            <img 
              className="li-icon" 
              src="/images/icons/how-long-to-hear-back.svg" 
              aria-hidden="true" 
              alt="" />
            <div className="li-info">
              <h3 className="multiline-heading">How long it takes to hear back</h3>
              <p>Processing your application takes about 45 days for Virginia residents and 90 days for out-of-state residents. Longer processing time may be required for certain applicants.</p>
              <p>We will send status updates to the email address you provide in your application.</p>
              <p>If your application is approved, you will then be required to schedule a visit using our online scheduling system.</p>
            </div>
          </li>
        </ul>
        <PrimaryButton 
            label="Begin Application"
            handleClick={this.handlePrimaryClick} 
            className="primary-button" />
      </div>
    )
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/pages/Landing/Landing.js